import type { MailboxCounters, MailboxSearchParams } from '@core/mailbox-types';
import { createSingleEntityStore, ngrxEvent } from '@core/ngrx-legacy';

const { actions, reducer, namespace, selectors } = createSingleEntityStore<MailboxCounters>()(
  'mailbox-counters',
  {
    customActions: () => ({
      fetch: ngrxEvent<Partial<MailboxSearchParams>>(),
      update: (state, { scope, delta }: { scope: keyof MailboxCounters; delta: number }) => ({
        ...state,
        data: {
          ...state.data,
          [scope]: Math.max(state.data[scope] ? state.data[scope] + delta : delta, 0),
        },
      }),
      set: (state, { scope, value }: { scope: keyof MailboxCounters; value: number }) => ({
        ...state,
        data: {
          ...state.data,
          [scope]: value,
        },
      }),
      setAll: (state, payload: { counters: MailboxCounters }) => ({
        ...state,
        data: payload.counters,
      }),
    }),
  },
);

const MailboxCountersActions = <
  Pick<typeof actions, 'fetch' | 'fetchSuccess' | 'fetchFailed' | 'update' | 'set' | 'setAll'>
>actions;

export {
  MailboxCountersActions,
  actions,
  reducer as MailboxCountersReducer,
  namespace as MailboxCountersNamespace,
  selectors as MailboxCountersSelectors,
};
